module.exports = __webpack_public_path__ + "media/images/pic/saska/saska_teenagers_bg-b138a75e7a161f333cfb2f3244d285bb.png";